import SpineLabeling from './SpineLabeling';

export default SpineLabeling;
